export default __webpack_public_path__ + "static/gateCode-97e8f12ea42731feae56442a4895751c.svg";